"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextWrapper = exports.LinkWrapper = exports.Image = exports.BottomWrapper = exports.Avatar = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _lazyImage = _interopRequireDefault(require("../../lazy-image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Avatar = (0, _styledComponents["default"])(_lazyImage["default"]).withConfig({
  displayName: "social-cardstyles__Avatar",
  componentId: "sc-4afyo4-0"
})(["height:45px;width:45px;border-radius:50%;object-fit:cover;"]);
exports.Avatar = Avatar;
var BottomWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "social-cardstyles__BottomWrapper",
  componentId: "sc-4afyo4-1"
})(["padding:12px;display:flex;color:", ";border-radius:0 0 8px 8px;", ""], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return (0, _css["default"])({
    backgroundColor: props.backgroundColor || 'plasma.base'
  });
});
exports.BottomWrapper = BottomWrapper;
var Image = (0, _styledComponents["default"])(_lazyImage["default"]).withConfig({
  displayName: "social-cardstyles__Image",
  componentId: "sc-4afyo4-2"
})(["object-fit:cover;width:238px;height:238px;"]);
exports.Image = Image;
var Link = (0, _styledComponents["default"])('a').withConfig({
  displayName: "social-cardstyles__Link",
  componentId: "sc-4afyo4-3"
})(["text-decoration:none;"]); // Wraps the social card in an anchor tag if it is provided with a link URL.

var LinkWrapper = function LinkWrapper(_ref) {
  var url = _ref.url,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, url ? /*#__PURE__*/_react["default"].createElement(Link, {
    href: url ? url : null,
    target: url ? '_blank' : null,
    rel: url ? 'noreferrer noopener' : null
  }, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children));
};

exports.LinkWrapper = LinkWrapper;
var TextWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "social-cardstyles__TextWrapper",
  componentId: "sc-4afyo4-4"
})(["padding-left:10px;display:flex;flex-direction:column;justify-content:space-between;"]);
exports.TextWrapper = TextWrapper;
var Wrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "social-cardstyles__Wrapper",
  componentId: "sc-4afyo4-5"
})(["width:238px;min-height:300px;overflow:hidden;user-select:none;"]);
exports.Wrapper = Wrapper;